module.exports = __webpack_public_path__ + "img/icon5_replace.42ece396.png";